import { type Component } from 'solid-js';
import { spacing } from './config';

// Vertical (the toolbar default): minimal spacing removes the inter-element
// padding, so the divider goes full-height and drops its horizontal margin to
// read as a clean seam. Any other density keeps the inset 50% rule and the
// mx-0.5 breathing room.
//
// Horizontal: always full-bleed. It separates stacked rows inside a pane, and
// an inset rule there reads as a gap in the list rather than a division of it.
export const Divider: Component<{ orientation?: 'vertical' | 'horizontal'; class?: string }> = (props) => {
    const horizontal = () => props.orientation === 'horizontal';

    const classes = () => (horizontal() ? 'w-full shrink-0 border-t' : `border-l ${spacing() === 'minimal' ? 'h-full' : 'h-[50%] mx-0.5'}`);

    return <div class={`${classes()}${props.class ? ` ${props.class}` : ''}`} />;
};
